import { isDateValid } from './validations/isDateValid';

const timeFormatter = new Intl.DateTimeFormat('ru', {
  hour: 'numeric',
  minute: 'numeric',
});

export const toTime = (date: Date | undefined): string | undefined => {
  if (!date) return;

  if (!isDateValid(date.toISOString())) return;

  return timeFormatter.format(date);
};
